<!-- Filter Panel -->
<div class="filter-panel">
  <div class="filter-header">
    <div class="filter-title">
      <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
        />
      </svg>
      Scheduled Campaign Filters
    </div>
    <div class="filter-actions">
      <button [disabled]="!isFilterApplied()" class="clear-btn" (click)="clearFilter()">
        Clear All
      </button>
      <button class="download-btn" (click)="downloadScheduledCampaign()">
        <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
          />
        </svg>
        Download
      </button>
    </div>
  </div>

  <div class="filter-content">
    <!-- Row 1: Date range & user filters (aligned with dashboard) -->
    <div class="filter-row" [style.--filter-cols]="filterColumnCount()">
      <div class="filter-group date-range-group" [formGroup]="dateRange">
        <div class="filter-label">Filter by Date Range</div>
        <div class="date-range-single-wrapper">
          <app-date-range-picker
            formControlName="range"
            placeholder="Select duration"
            dropdownAlign="right"
          />
        </div>
      </div>

      @if (isAdmin()) {
        <div class="filter-group user-group">
          <div class="filter-label">Reseller</div>
          <div class="select-wrapper">
            <select
              class="user-select"
              [ngModel]="selectedResellerId() ?? ''"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onUserSelect($event)"
            >
              <option value="">All Resellers</option>
              @for (user of userOptions(); track user._id) {
                <option [value]="user._id">{{ user.label }}</option>
              }
            </select>
            <svg class="select-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
      }

      @if (isAdmin() || isReseller()) {
        <div class="filter-group user-group">
          <div class="filter-label">Sub Reseller</div>
          <div class="select-wrapper">
            <select
              class="user-select"
              [ngModel]="selectedSubResellerId() ?? ''"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onSubResellerSelect($event)"
            >
              <option value="">All Sub Resellers</option>
              @for (user of subResellerOptions(); track user._id) {
                <option [value]="user._id">{{ user.label }}</option>
              }
            </select>
            <svg class="select-chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
      }
    </div>

    <!-- Row 2: Search & status -->
    <div
      class="filter-row filter-row-secondary"
      [class.filter-row-single-col]="filterColumnCount() === 1"
      [style.--filter-cols]="filterColumnCount()"
    >
      <div class="filter-group search-group">
        <div class="filter-label">Search</div>
        <div class="date-input-container">
          <div class="search-box">
            <svg
              class="search-icon"
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <input
              type="text"
              class="search-input"
              placeholder="Search by campaign name and number..."
              [value]="searchTerm()"
              (input)="onSearch($event.target.value)"
            />
          </div>
        </div>
      </div>

      <div class="filter-group status-group">
        <div class="filter-label">Filter by Status</div>
        <div class="date-input-container">
          <div class="chip-container">
            @for (status of statuses(); track status) {
              <button
                type="button"
                class="chip"
                [class.active]="activeStatus() === status"
                (click)="setActiveStatus(status)"
              >
                {{ status }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (!isLoading() && scheduledCampaignList().length) {
  <div class="table-card">
    <div class="table-responsive">
      <table class="data-table">
        <thead>
          <tr>
            <th>Campaign Name</th>
            <th>Sender ID</th>
            <th>Date (THA)</th>
            <th>Schedule Date (THA)</th>
            <th>Reseller</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (entry of scheduledCampaignList(); track $index) {
            <tr>
              <td>{{ entry.campaignName || '-' }}</td>
              <td>{{ entry.senderId }}</td>
              <td>{{ entry.date }}</td>
              <td>{{ entry.scheduleDate }}</td>
              <td>{{ entry.reseller }}</td>
              <td>
                <span class="status-badge" [ngClass]="entry.status?.toLowerCase()">{{
                  entry.status
                }}</span>
              </td>
              <td>
                @if (entry.status === 'Pending') {
                  <div class="action-btns">
                    <button class="delete-btn" (click)="onDelete(entry)">
                      <svg
                        width="18"
                        height="18"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        />
                      </svg>
                    </button>
                  </div>
                } @else {
                  -
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination
      [totalItems]="totalItems()"
      [pageSize]="pageSize()"
      [currentPage]="currentPage()"
      itemName="entries"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
    />
  </div>
}

@if (!isLoading() && !scheduledCampaignList().length) {
  <app-data-not-found [message]="'No scheduled campaigns found'" />
}

@if (isLoading()) {
  <app-loader />
}

<!-- Delete Confirmation Modal -->
@if (isDeleteModalOpen()) {
  <div
    class="modal-backdrop"
    (click)="$event.target === $event.currentTarget && closeDeleteModal()"
    (keydown.escape)="closeDeleteModal()"
    role="presentation"
  >
    <div class="modal-container delete-modal">
      <div class="modal-header">
        <h2 class="modal-title">Confirm Cancellation</h2>
        <button class="close-modal-btn" (click)="closeDeleteModal()">
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <div class="modal-body text-center">
        <div class="delete-icon-wrapper">
          <svg width="48" height="48" fill="none" stroke="#ef4444" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
        </div>
        <p class="delete-message">
          Are you sure you want to cancel the scheduled campaign
          <strong>{{ campaignToDelete()?.campaignName || 'this campaign' }}</strong
          >? This action cannot be undone.
        </p>
      </div>

      <div class="modal-footer">
        <button type="button" class="modal-btn cancel" (click)="closeDeleteModal()">
          No, Keep it
        </button>
        <button type="button" class="modal-btn delete" (click)="confirmDelete()">
          Yes, Cancel Campaign
        </button>
      </div>
    </div>
  </div>
}
